import axios from "axios";
import api, { callRefreshToken } from "../config/http-common";

export const getAllTasks = async (
  payload,
  pageNumber = 1,
  pageSize = 10000
) => {
  let url = `/tasks?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  if (payload?.name) {
    url += `&title=${encodeURIComponent(payload.name)}`;
  }
  if (payload?.status) {
    url += `&status=${encodeURIComponent(payload.status)}`;
  }
  if (payload?.projectIds) {
    url += "&projectIds=" + payload.projectIds;
  }
  if (payload?.startDate) {
    url += `&startDate=${encodeURIComponent(payload.startDate)}`;
  }
   if (payload?.endDate) {
    url += `&endDate=${encodeURIComponent(payload.endDate)}`;
  }
  const value = await callRefreshToken();
  if (value == true) return await api.securedAxiosApi().get(url);
};

export const getTasksByProjectId = async (projectId, pageNumber, pageSize) => {
    let url = "/tasks/project/";
    if (pageNumber && pageSize) {
        url += projectId + "?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    } else {
        url += projectId;
    }
    const value = await callRefreshToken();
    if (value == true)
        return await api.securedAxiosApi().get(url);
};

export const createTask = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().post("/task", payload);
};

export const getTaskById = async (id) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get("/tasks/" + id);
};

export const updateTaskById = async (id, payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().put("/tasks/" + id, payload);
};

export const softDeleteTask = async (id) => {
  const value = await callRefreshToken();
  if (value == true) return await api.securedAxiosApi().delete("/tasks/" + id);
};

export const batchTasksArchive = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api
      .securedAxios()
      .delete(
        `${process.env.REACT_APP_SERVER_URL?.replace(
          "/web",
          "/api/v1"
        )}/tasks/archive`,
        { data: payload }
      );
};

export const batchTasksUnarchive = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api
      .securedAxios()
      .put(
        `${process.env.REACT_APP_SERVER_URL?.replace(
          "/web",
          "/api/v1"
        )}/tasks/unarchive`,
        payload
      );
};

export const batchTasksComplete = async (payload) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api
      .securedAxios()
      .put(
        `${process.env.REACT_APP_SERVER_URL?.replace(
          "/web",
          "/api/v1"
        )}/tasks/complete`,
        payload
      );
};

export const exportTaskReportByMember = async (
  projects,
  member,
  startTime,
  endTime
) => {
  try {
    const requestBody = {
      projects: Array.isArray(projects) ? projects : projects ? [projects] : [],
      member: member || null,
      startDate: startTime || null,
      endDate: endTime || null,
    };

    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + "/reports/tasks/export",
        requestBody,
        {
          responseType: "blob", // Important to specify the response type as blob
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName = "Task_reports.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the task report", error);
  }
};

